import { IApplicationState } from '../../types/redux';

export const selectIsBrokerAvailability = (state: IApplicationState): boolean =>
  state.brokerAvailability?.partnerRewardsRegistrationStatus === 'connected' ||
  state.brokerAvailability?.partnerRewardsRegistrationStatus === 'inProgress';
